import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAppBranding } from '../../config/branding';
import { useBranding } from '../../context/BrandingContext';
import charger from '../../utils/api/charger';

/**
 * Navbar component
 */
function Navbar() {
  const { i18n } = useTranslation();
  const { brandData } = useBranding();
  const { images: brandImage } = useAppBranding();
  const [chargerDetails, setChargerDetails] = useState<{
    chargingPointName: string;
    stationName: string;
  }>({
    chargingPointName: '',
    stationName: '',
  });
  const { deviceId } = useParams<{ deviceId: string }>(); // Extracts the ID from the URL

  /**
   * Get charger details
   */
  const getChargerDetails = async () => {
    try {
      const response = await charger.fetchLocationByEvse(deviceId ?? '');
      const apiResponse = response.data;
      const stationName =
        apiResponse?.location?.name ||
        apiResponse?.data?.location?.name ||
        apiResponse?.chargingStation?.name ||
        '';
      const pointName =
        apiResponse?.evseId ||
        apiResponse?.data?.evseId ||
        apiResponse?.chargingPointName ||
        (deviceId ? `EVSE ${deviceId}` : '');

      setChargerDetails({
        chargingPointName: pointName,
        stationName,
      });
    } catch (error: any) {
      console.error('Failed to fetch charger details:', error);
    }
  };
  useEffect(() => {
    if (deviceId) {
      getChargerDetails();
    }
  }, [deviceId]);

  const logo = brandData?.logoUrl || brandData?.logo || brandImage.logo;

  return (
    <div className={`navbar-wrap ${i18n.dir() === 'rtl' ? 'rtl' : ''}`}>
      <img
        src={logo}
        alt=""
        className={`navbar-logo ${brandData?.clientName === 'saqr-tech' ? 'saqr-tech' : ''}`}
      />{' '}
      <div className="left-pane">
        {chargerDetails.chargingPointName && <p>{chargerDetails.chargingPointName}</p>}
        {chargerDetails.stationName && <p>{chargerDetails.stationName}</p>}
      </div>
    </div>
  );
}

export default Navbar;
